/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import Footer from './common/Footer';
import Product from './common/Product';
import LinkButton from './common/LinkButton';
import Button from './common/Button';

function Conclusion({
  body, head, links,
}) {
  const { t } = useTranslation();
  function getBodyMarkup() {
    return { __html: head || body };
  }

  function listProductsOrLinks() {
    return links.map((x) => {
      if (x.image) {
        return (
          <div className="product-container" key={x.label}>
            <Product
              label={x.label}
              solution={x.solution}
              image={x.image}
              description={x.description}
              href={x.href}
            />
          </div>
        );
      }
      return (
        <div className="mt-4" key={x.label}>
          <LinkButton name={x.label} label={x.label} href={x.href} />
        </div>
      );
    });
  }

  function scroll(event) {
    event.preventDefault();
    document.querySelector('#conclusion').scrollIntoView({
      behavior: 'smooth',
    });
  }

  function getResultButton() {
    return (
      <div className="text-center">
        <Button
          cssClass="btn result"
          name="goto-conclusion"
          label={t('common.result')}
          onClick={scroll}
        />
      </div>
    );
  }

  return (
    <>
      <div className="d-flex flex-column mb-4">
        <div className={head && 'aware-note'}>
          <div className="container pb-4">
            <p className="open-sans" dangerouslySetInnerHTML={getBodyMarkup()} />
            {(isMobileOnly && head) && getResultButton()}
          </div>
        </div>
        <div className="container">
          <div id="conclusion" className="d-flex flex-wrap">
            {listProductsOrLinks()}
          </div>
        </div>
      </div>
      <Footer result />
    </>
  );
}

Conclusion.propTypes = {
  body: PropTypes.string,
  head: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.any),
};

Conclusion.defaultProps = {
  links: null,
  head: null,
  body: null,
};

export default Conclusion;
